import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import CBModal from './CBModal';
import GedFileField from './GedFileField';

/**
 * Joindre la fiche de déclaration du bureau homologue à un dossier TE, et enregistrer
 * la demande de confirmation de garantie qu'elle porte.
 *
 * Deux usages depuis la fiche du dossier :
 *  - la fiche manque (échec à la déclaration, dossier antérieur) : on la joint ;
 *  - elle est déjà dans la GED mais le dossier est resté en NOUVEAU : il ne reste
 *    qu'à enregistrer la demande, aucun fichier n'est demandé.
 *
 * `enregistrerDemande` dit si la validation fera aussi passer le dossier en attente
 * de confirmation (dossier en NOUVEAU et droit de gérer la garantie).
 */
export default function FicheHomologueModal({ open, onClose, onConfirm, loading, dejaJointe, enregistrerDemande }) {
  const { t } = useTranslation('commun');
  const [fichier, setFichier] = useState(null);

  useEffect(() => { if (open) setFichier(null); }, [open]);

  const okText = dejaJointe
    ? t('ficheHomologueModal.demanderGarantie')
    : enregistrerDemande ? t('ficheHomologueModal.joindreEtDemander') : t('ficheHomologueModal.joindreFiche');

  return (
    <CBModal
      title={t('ficheHomologueModal.titre')}
      open={open}
      onCancel={onClose}
      onOk={() => onConfirm(fichier)}
      okText={okText}
      cancelText={t('ficheHomologueModal.annuler')}
      width={600}
      confirmLoading={loading}
      okButtonProps={{ disabled: !dejaJointe && !fichier, style: { background: '#1a6b3c', borderColor: '#1a6b3c' } }}
    >
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message={t('ficheHomologueModal.alerteTitre')}
        description={
          enregistrerDemande
            ? t('ficheHomologueModal.alerteAvecDemande')
            : t('ficheHomologueModal.alerteSansDemande')
        }
      />
      {dejaJointe ? (
        <p style={{ margin: 0 }}>
          {t('ficheHomologueModal.dejaJointe')}
        </p>
      ) : (
        <GedFileField value={fichier} onChange={setFichier} required hint={t('ficheHomologueModal.classeeDansGed')} />
      )}
    </CBModal>
  );
}
